import { render, staticRenderFns } from "./SupportTicketTypingIndicator.vue?vue&type=template&id=7c9deb2d&scoped=true&"
import script from "./SupportTicketTypingIndicator.vue?vue&type=script&lang=ts&"
export * from "./SupportTicketTypingIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./SupportTicketTypingIndicator.vue?vue&type=style&index=0&id=7c9deb2d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9deb2d",
  null
  
)

export default component.exports